
interface Action {
    payload: any,
    type: string,
    field: string,
    value?: any,
    validate: boolean
}

const errors: {
    [key: string]: string
} = {
    fullName: "Please add a full name.",
    lastName: "Please add a full name.",
    email: "Email is required.",
    validEmail: "Please add a valid email address.",
    validPhone: "Please add a valid phone number.",
    password: "Password is required.",
    phone: "Phone number is required.",
};

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,50}$/;


const Validate = (data: any, action: Action) => {
    const newForm = data;
    const prop = newForm[action.field];
    if (prop) {
        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true
        }
        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }
        if (action.field === 'fullName') {
            if (action.value) {
                const name = action.value.split(' ').filter((el: any) => el !== '');
                newForm.firstName.value = name[0];
                newForm.firstName.error = !name[0] ? errors.fullName : '';
                name.shift();
                newForm.lastName.value = name.join(' ');
                const l = newForm.lastName.value && newForm.lastName.value.length > 1 ? newForm.lastName.value?.trim() : true;
                newForm.lastName.error = !newForm.lastName.value || !l ? errors.lastName : '';
            } else {
                newForm.firstName.error = errors.fullName;
                newForm.firstName.value = '';
            }
        }
        if (action.field === 'email') {
            prop.error = !emailPattern.test(action.value) ? errors['validEmail'] : null;
        } else if (action.field === 'phone') {
            prop.error = !action.value || `${action.value}`.length < 10 ? errors['validPhone'] : null
            //return (!phone || phone && phone.trim('').length < 14) ? this.FormErrors.phoneNumber : false;
        } else {
            prop.error = (prop.added && !action.value && prop.required) ? errors[action.field] : null;
        }
        prop.value = action.value;
    }
    const vals = Object.values(newForm).filter((f: any) => f.required);
    const valid = vals.filter((f: any) => f.added && f.value && !f.error);
    return {
        changed: true,
        valid: valid.length === vals.length,
        data: newForm,
    };
};

const Setup = (data: any, action: Action) => {
    const newForm = data;
    const {payload} = action;

    newForm.fullName.value = `${payload.first_name} ${payload.last_name}`;
    newForm.fullName.added = !!newForm.fullName.value;

    newForm.firstName.value = payload.first_name;
    newForm.firstName.added = !!newForm.firstName.value;

    newForm.lastName.value = payload.last_name;
    newForm.lastName.added = !!newForm.lastName.value;

    newForm.businessName.value = payload.business_name;
    newForm.businessName.added = !!payload.business_name;

    newForm.email.value = payload.email;
    newForm.email.added = !!newForm.email.value;
    newForm.email.error = !emailPattern.test(payload.email) ? errors['validEmail'] : null;

    newForm.phone.value = payload.phone;
    newForm.phone.added = !!newForm.email.value;
    newForm.phone.error = action.value && `${action.value}`.length < 10 ? errors['validPhone'] : null;

    return {
        changed: false,
        valid: true,
        data: newForm,
    }
};

export {
    Setup,
    Validate
}
